import {
  FC,
  useMemo,
  useState
} from "react";
import {
  View,
  Pressable,
  Modal
} from "react-native";
import DatePicker, { useDefaultClassNames, DateType } from "react-native-ui-datepicker";
import CalendarIcon from "assets/icons/main/calendarIcon.svg";
import dayjs   from "dayjs";
import { BACKEND_DATE_FORMAT } from "@/_utils/formatDate";
import { MaskedTextInput } from "react-native-mask-text";

interface IDatePickerProps {
  value: string;
  onChange: (date: string) => void;
  className?: string;
  placeholder?: string;
}

type DefaultClassNamesType = ReturnType<typeof useDefaultClassNames>;
//TODO: доработать компонент, нет возможности ручного ввода даты
const DatePickerField: FC<IDatePickerProps> = ({
  value,
  onChange,
  className,
  placeholder = "Выберите дату",
  }) => {
  const [open, setOpen] = useState<boolean>(false);
  const handleSelect = (params: { date: DateType }): void => {
    if (!params?.date) return;

    const formatted: string = dayjs(params.date).format(BACKEND_DATE_FORMAT);
    onChange(formatted);
    setOpen(false);
  };

  const handleOpen = (): void => setOpen(true);
  const handleClose = (): void => setOpen(false);
  const stopPropagation = (e: any) => e.stopPropagation();

  const defaultClassNames: DefaultClassNamesType = useDefaultClassNames();
  const selectedDate: Date = value ? dayjs(value).toDate() : new Date();
  const minDate: Date = dayjs("1925-01-01").toDate();
  const maxDate: Date = dayjs().toDate();

  const displayValue: string = useMemo((): string => {
    if (!value) return "";

    return dayjs(value).format("DD.MM.YYYY");
  }, [value]);

  return (
    <View>
      <Pressable onPress={handleOpen}>
        <MaskedTextInput
          mask="99.99.9999"
          // TODO: ручной ввод даты временно недоступен
          editable={false}
          className={className}
          placeholder={placeholder}
          value={displayValue}
          onChangeText={() => null}
        />
        <View className="absolute right-4 top-6 -translate-y-1/2">
          <CalendarIcon width={20} height={20} />
        </View>
      </Pressable>
      <Modal visible={open} transparent animationType="fade">
        <Pressable
          className="flex-1 justify-center bg-black/30"
          onPress={handleClose}
        >
          <Pressable
            className="mx-6 rounded-xl bg-white p-4"
            onPress={stopPropagation}
          >
            <DatePicker
              mode="single"
              date={selectedDate}
              minDate={minDate}
              maxDate={maxDate}
              onChange={handleSelect}
              locale = "ru"
              classNames={{
                ...defaultClassNames,
                today: "border-blue-500 rounded-full border",
                selected: "bg-blue-500 rounded-full border-blue-500",
                selected_label: "text-white font-semibold",
                day: `${defaultClassNames.day} hover:bg-blue-100`,
                disabled: "opacity-40",
              }}
            />
          </Pressable>
        </Pressable>
      </Modal>
    </View>
  );
};

export default DatePickerField;
